var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$offline)?_c('page-500',{attrs:{"back":_vm.backFromOffline,"message":_vm.$t('shared.YouAreOffline')}}):_c('div',[_c('progress-bar'),_c('notifications'),(_vm.isPublic)?_c('pub'):_c('cp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }